function setState (state, payload) {
  let removeReactivity = false
  if (payload._removeReactivity) {
    removeReactivity = true
    delete payload._removeReactivity
  }
  for (const key in payload) {
    if (Object.prototype.hasOwnProperty.call(state, key)) {
      if (typeof payload[key] === 'object' && removeReactivity) {
        state[key] = JSON.parse(JSON.stringify(payload[key]))
      } else {
        state[key] = payload[key]
      }
    } else {
      console.warn(`Key ${key} does not exist in state`)
    }
  }
}
export default {
  setState,
  SET_ROWS (state, payload) {
    state.rows = payload
  },
  SET_ROW (state, payload) {
    state.row = payload
  },
  REMOVE_ROWS (state) {
    state.rows = []
  },
  REMOVE_ROW (state) {
    state.row = {}
  },
  DELETE_ROW (state, payload) {
    state.rows = state.rows.filter(row => row.id !== payload.id)
  },
  SET_PAGINATION (state, payload) {
    state.pagination = {
      total: payload.total ?? state.pagination.total,
      last_page: payload.last_page ?? state.pagination.last_page,
      current_page: payload.current_page ?? state.pagination.current_page,
      per_page: payload.per_page ?? state.pagination.per_page
    }
  },
  SET_SEARCH_INFO (state, payload) {
    state.searchInfo = payload
  },
  SET_ORDER_BY (state, payload) {
    state.orderBy = payload
  },
  SET_ITEM_PER_PAGE (state, payload) {
    state.tableOptions = {
      itemsPerPageOptions: payload
    }
  },
  SET_ERRORS (state, payload) {
    state.errors = payload
  },
  REMOVE_ERRORS (state) {
    state.errors = {}
  }
}
